/**
 * 全局常量、方法封装模块
 * 通过原型挂载到Vue属性
 * 通过 this.Global 调用
 */

  // 后台管理系统服务器地址
export const baseUrl = "/xhhyApi"

// 系统数据备份还原服务器地址
// export const backupBaseUrl = 'http://192.168.1.160:8036/xhhy'
export const backupBaseUrl = 'http://localhost:8081/xhhy'

export default {
  baseUrl,
  backupBaseUrl
}



// WEBPACK FOOTER //
// ./src/utils/global.js